module.exports = __webpack_public_path__ + "img/18.a34acca0.svg";